import { parseEnv, sharedEnv } from "@songtradr-sso/shared/common";
import { FrontendEnvironmentSchema } from "./env.schema";

const parsedEnv = parseEnv<typeof FrontendEnvironmentSchema>(
  FrontendEnvironmentSchema,
);

export const env = {
  ...sharedEnv,
  nodeEnv: parsedEnv.NODE_ENV,
} as const;
